export default __webpack_public_path__ + "assets/902a808caae0fe6569dafcf8e471f66d.png";